import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { useTranslation } from "react-i18next";
import { FieldServiceGroup } from '../../../domain/FieldServiceGroup';
import Can from '../../../components/Can';
import { Publisher } from '../../../domain/Publisher';
import MobileFieldServiceGroupTableRow from './MobileFieldServiceGroupTableRow';

interface Props {
    groups: FieldServiceGroup[];
    publishers: Publisher[];
    onGroupEdit: (group: FieldServiceGroup) => void;
    onPublisherEdit: (publisher: Publisher) => void;
}

const MobileFieldServiceGroupTable = (props: Props) => {
    const { t } = useTranslation();

    return (
        <TableContainer>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell>{t("name")}</TableCell>
                        <Can do="manage" on='Groups'>
                            <TableCell>{t("actions")}</TableCell>
                        </Can>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {props.groups && props.groups
                        .slice() // copy the array because sorting mutates original array
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((group: FieldServiceGroup) => (
                            <MobileFieldServiceGroupTableRow
                                key={group.id}
                                group={group}
                                publishers={props.publishers.filter(publisher => publisher.serviceGroup && publisher.serviceGroup.id === group.id)}
                                onGroupEdit={props.onGroupEdit}
                                onPublisherEdit={props.onPublisherEdit}
                            />
                        ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default MobileFieldServiceGroupTable;